import React, { Component } from 'react'
import { Grid, GridCell } from 'rmwc/Grid'
import { ListDivider } from 'rmwc/List'
import { Typography } from 'rmwc/Typography'
import { Button } from 'rmwc/Button'
import { connect } from 'react-redux'
import { Radio } from 'rmwc/Radio'
import { Select } from 'rmwc/Select'
import { Card } from 'rmwc/Card'
import { Link } from 'react-router-dom'
import { TextField } from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'


class AdminDisplayConfigurationAddUpdate extends Component {

	constructor(props){
		super(props);
		this.state = {
			errorMsg: '',
			initalLoadingComplete: false,
      initalNameState: '',
			data: {
				id: 0,
				name: '',
				imgLink: '',
				targetLink: '',
				active: 1,
				listingSequence: '',
				parentId: '',
				topLevelEntities: [],
				section: 'Dashboard'
			},
			formErrors:{
				nameError: '',
				imgLinkError: '',
				targetLinkError: '',
				activeError: 1,
				listingSequenceError: '',
				parentIdError: '',
			},
			disableState:{
				sectionDisable: true,
				updateParentDisable: false,
        addUpdateButtonDisable: false
			}
		}
	}

	componentDidMount(){
		let data = Object.assign({}, this.state.data)
    let initalNameState = this.state.initalNameState
		let disableState = Object.assign({}, this.state.disableState)
		let recordId = parseInt(this.props.match.params.id)
		data.id = recordId
		let urlFetchParentEntities = `fetch/display/configurations/top/level/entities?type=Dashboard`
		api.getResponse(this.props.user.accessToken, urlFetchParentEntities)
    .then((result) => {
      data.topLevelEntities = result.data
      if(recordId === 0){
        this.setState({data: data, initalLoadingComplete: true})
        return
      }
      else {
        let url = `admin/display/configurations/show?id=${recordId}&section=Dashboard`
        api.getResponse(this.props.user.accessToken, url).then((result) => {
          if(result.status === 'success'){
            data.id = result.data.id
            data.name = result.data.name
            initalNameState = result.data.name
            data.imageLink = result.data.image_link
            data.targetLink = result.data.target_link
            data.listingSequence = result.data.listing_sequence
            data.parentId = result.data.parent_id
            data.section = result.data.section
            data.active = result.data.active
            if(!data.parentId){
            disableState.updateParentDisable = true
            }
            this.setState({data: data, initalLoadingComplete: true, disableState: disableState, initalNameState: initalNameState})
          }
          else{
            this.setState({errorMsg: result.message})
          }
        })
      }
    }).catch((err)=>{
      this.setState({errorMsg: "Error in fetching details"})
    })
	}

	goBack = (e) => {
		e.preventDefault()
		this.props.history.push('/portal/app/admin/display/configuration/home')
	}

	onInputChange = (e) => {
		let data = Object.assign({}, this.state.data)
		data[e.target.name] = e.target.value
		this.setState({data: data})
	}


	handleParentChange = (e) => {
		let data = Object.assign({}, this.state.data)
		data.parentId = e.target.value
		this.setState({data: data})
	}

	handleAddConfig = (e) => {
		e.preventDefault()
    let disableState = Object.assign({}, this.state.disableState)
		if(this.validform()){
			let url ='admin/display/configurations/create'
      let apiInput = {
        'name': this.state.data.name,
        'image_link': this.state.data.imageLink,
        'target_link': this.state.data.targetLink,
        'parent_id': this.state.data.parentId,
        'active': this.state.data.active,
        'listing_sequence': this.state.data.listingSequence
      }

      api.postValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          disableState.addUpdateButtonDisable = true
          this.setState({ errorMsg: result.message, disableState: disableState })
        } 
        else{
          this.setState({ errorMsg: result.message })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }

  handleupdateConfig = (e) => {

    if(this.validform()){
      let disableState = Object.assign({}, this.state.disableState)
      let url =`admin/display/configurations/update/${this.state.data.id}`
      let apiInput
      let name = this.state.data.name
      let initalNameState = this.state.initalNameState
      if(name == initalNameState){
        apiInput = {
          'image_link': this.state.data.imageLink,
          'target_link': this.state.data.targetLink,
          'parent_id': this.state.data.parentId,
          'active': this.state.data.active,
          'listing_sequence': this.state.data.listingSequence
        }
      }
      else {
        apiInput = {
          'name': this.state.data.name,
          'image_link': this.state.data.imageLink,
          'target_link': this.state.data.targetLink,
          'parent_id': this.state.data.parentId,
          'active': this.state.data.active,
          'listing_sequence': this.state.data.listingSequence
        }
      }
      api.putValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          disableState.addUpdateButtonDisable = true
          this.setState({ errorMsg: result.message, disableState: disableState })
        } 
        else{
          this.setState({ errorMsg: result.message })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
    else {
      this.setState({errorObj: 'Validation issue'})
    }
  }

  validform() {
  	let error = true
    let disableState = Object.assign({}, this.state.disableState)
  	let errorObj = Object.assign({},this.state.formErrors)
  	let data = Object.assign({}, this.state.data)

  	errorObj.nameError= ''
		errorObj.imgLinkError= ''
		errorObj.listingSequenceError= ''
		errorObj.parentIdError= ''

  	if (!data.name){
  		errorObj.nameError = 'Name is Mandatory'
  		error = false
  	}

  	if ((!disableState.updateParentDisable) && (!data.imageLink)){
  		errorObj.imgLinkError = 'Image Link is Mandatory'
  		error = false
  	}

  	if (!data.listingSequence){
  		errorObj.listingSequenceError = 'Listing Sequence is Mandatory'
  		error = false
  	}
    
  	if ((data.imageLink) && (!data.parentId)){
  		errorObj.parentIdError = 'Entity is Mandatory'
  		error = false
  	}
  	this.setState({formErrors: errorObj})
  	return error
  }


  


	render(){
		let addUpdateButtonComponent
 

		if(this.state.data.id === 0){
			addUpdateButtonComponent=(
			<GridCell span="12">	<Button raised onClick={this.handleAddConfig} disabled={this.state.disableState.addUpdateButtonDisable}>Add Configuration</Button></GridCell>
				)
		}
		else{
			addUpdateButtonComponent=(
				<GridCell span="12">	<Button raised onClick={this.handleupdateConfig} disabled={this.state.disableState.addUpdateButtonDisable}>Update Configuration</Button></GridCell>
				)
		}

		return(
			<div>    
  	    <Card style={{padding: '1px'}}>
          <Grid>
	            <GridCell span="11">
	              <Typography use="headline6">Add/Update Configuration</Typography>
	            </GridCell>
		          <GridCell span = "1">
		          	<Button raised onClick={this.goBack}>Back</Button>
		          </GridCell>
            </Grid>
      	</Card>
      		
      	<Grid>
      		<GridCell span="6">
      				<TextField  className='text_input' label= 'Section' autoComplete="off" name="section" onChange={this.onInputChange} value={this.state.data.section} disabled={this.state.disableState.sectionDisable}/>
      		</GridCell>
      		<GridCell span="6">
      				<TextField  className='text_input' label= 'Name' autoComplete="off" name="name" onChange={this.onInputChange} value={this.state.data.name} disabled={this.state.disableState.updateParentDisable}/>
      		</GridCell>
      		<GridCell span="6">
      				<TextField  className='number' label= 'Listing Sequence' autoComplete="off" name="listingSequence" onChange={this.onInputChange} value={this.state.data.listingSequence}/>
      		</GridCell>
      		<GridCell span="6">
      				<div className ="full-width">
      						<div className="mdc-select" role="listbox">
      								<select
      										name="parentId"
      										onChange={this.handleParentChange}
      										value={this.state.data.parentId}
      										className="mdc-select__native-control two-col-input"
      										disabled={this.state.disableState.updateParentDisable}
      										>
      										<option value="" selected="">--Select Top Level Entity--</option>
                          {this.state.data.topLevelEntities.map(entity => (
                            <option key={entity.id} value={entity.id} data-name={entity.name}>
                              {entity.name}
                            </option>
                          ))}
                      </select>
      						</div>
      				</div>
      		</GridCell>
      		<GridCell span="12">
          	Status:
          	<Radio name="active" value={1} checked={this.state.data.active == '1'} onChange={this.onInputChange}> Active </Radio>
          	<Radio name="active" value={0} checked={this.state.data.active == '0'} onChange={this.onInputChange}> In Active </Radio>
        	</GridCell>
      		<GridCell span="12">
      				<TextField  fullwidth className='text_input' label= 'Image Link' autoComplete="off" name="imageLink" onChange={this.onInputChange} value={this.state.data.imageLink} disabled={this.state.disableState.updateParentDisable}/>
      		</GridCell>
      		<GridCell span="12">
      				<TextField  fullwidth className='text_input' label= 'Target Link' autoComplete="off" name="targetLink" onChange={this.onInputChange} value={this.state.data.targetLink} disabled={this.state.disableState.updateParentDisable}/>
      		</GridCell>
      		{addUpdateButtonComponent}  
      		<GridCell span = "12">
      				<StatusMessage error_msg = {this.state.errorMsg}/>
      				<StatusMessage error_msg = {this.state.formErrors.nameError}/>
      				<StatusMessage error_msg = {this.state.formErrors.listingSequenceError}/>
      				<StatusMessage error_msg = {this.state.formErrors.parentIdError}/>
      				<StatusMessage error_msg = {this.state.formErrors.imgLinkError}/>
      		</GridCell>

      	</Grid>
      </div>
		)
	}
}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDisplayConfigurationAddUpdate);


// WEBPACK FOOTER //
// ./src/views/admin/AdminDisplayConfigurationAddUpdate.jsx